module.exports = __webpack_public_path__ + "static/media/mainChart2.897b5fd4.png";